import * as api from 'common/api'

// 获取初始密码
export let getOriginPassword = params => api.get('account/password/reset', params)

// 重置人员密码
export let resetPassword = params => api.post('account/password/reset', params)

// 登录
export let login = params => api.post('account/login', params)

// 获取当前用户信息
export let own = () => api.get('account/own')

// 登出
export let logout = () => api.post('account/logout')



// WEBPACK FOOTER //
// ./src/api/account.js